const getDefaultMessage = () => {
    return {
        data: {
            type: "",
            text: ""
        },
        error: false
    }
}

const convertServerMessageToChatMessageInfo = (message) => {
    let newMessageInfo = getDefaultMessage();
    newMessageInfo.data = message;
    return newMessageInfo;
}

const generateChatMessagesListFromServerMessagesList = (serverMessagesList) => {
    return serverMessagesList.map((message) => {
        return convertServerMessageToChatMessageInfo(message);
    });
}

const getDefaultNewChoice = (value, choiceOrderId) => {
    return {
        value: value ? value : null,
        label: "",
        choice_is_hidden: false,
        choice_order_id: choiceOrderId ? choiceOrderId : null
    };
};

const getDefaultNewQuestion = () => ({
    question: "",
    options: {noDKNA: "true"},
    type: "singleChoice",
    choices: [getDefaultNewChoice('1', 0)],
    predefinedQuestion: false
});

const getRandomAwaitingResponseMessage = () => {
    let messages = ["Just count to 10", "Let's take a mindfulness minute...", "Time flies when you’re having fun.",
        "We need more coal", "“To lose the patience is to lose the battle” - Mahatma Gandhi",
        "“Patience is bitter, but its fruit is sweet” - Jean-Jacques Rousseau",
        "“It does not matter how slowly you go as long as you do not stop” - Confucius",
        "Patience is when you’re supposed to get mad, but you choose to understand",
        "Don't worry - a few bits tried to escape, but we caught them", "We're testing your patience",
        "The bits are flowing slowly today", "It's still faster than you could draw it", "Counting backwards from Infinity",
        "Unicorns are at the end of this road, I promise", "Cleaning off the cobwebs...",
        "Making sure all the i's have dots...", "Discovering new ways of making you wait...", "Almost there… just a few more digital gears to turn",
        "Patience is a virtue, speed is a perk",
        "Good things come to those who wait...and wait…",
        "Turning the wheels of progress… slowly",
        "Zen is just one loading bar away",
        "Shuffling some bytes...and wisdom",
        "If you had a penny for every second waited, you’d have... pennies",
        "It’s worth the wait, we promise",
        "Breathing in... breathing out... code is complicated",
        "Loading wisdom, 1% complete",
        "Working on something amazing… we hope",
        "Fine-tuning the magic",
        "Your wait is our motivation",
        "Contemplating the mysteries of the universe... and our servers",
        "Smiling at the progress bar helps it move... try it!",
        "The pixels are aligning… slowly but surely",
        "Sending data by carrier pigeon... almost here",
        "Good things come to those who click",
        "Our code takes coffee breaks too",
        "Counting down… or up? We’ll never tell",
        "If loading was a race, we’d be... not first",
        "Preparing your digital feast, one byte at a time",
        "Where there's a load bar, there’s hope",
        "Time flies when you’re... patiently waiting?",
        "Let’s take this slow and steady",
        "Remember: Every loading screen is just progress in disguise",
        "To load or not to load… that is the question",
        "No progress without patience",
        "Savoring each byte… and taking our time",
        "Waiting is just the prelude to awesome"
    ];
    let messageIdx = Math.floor(Math.random() * messages.length);
    return messages[messageIdx];
};

const questionTypeNamesMap = {
    'singleChoice': 'Single choice',
    'multipleChoice': 'Multiple choice',
    'jumbotron': 'Info text',
    'text': 'Open-ended',
    'selects':'matrix'
};

const calculateSurveyLoi = (quest) => {
    const loi = quest.questions.map(q => {
        switch (q.type) {
            case "singleChoice":
            case "multipleChoice":
                return 0.5;
            default:
                return 0;
        }
    }).reduce((acc, curr) => acc + curr, 0);

    return Math.ceil(loi);
};

const countryNamesMap = {
    'id': 'Indonesia',
    'ro': 'Romania',
    'ph': 'the Philippines'
};

const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const getCountryNameForDomainPrefix = (domainPrefix) => {
    return countryNamesMap[domainPrefix] ? countryNamesMap[domainPrefix] : capitalizeFirstLetter(domainPrefix);
};

const generatePreviewLink = (questId, questHash) => {
    let surveyUrl = window.quisitoWebsiteConfig.SURVEY_MODULE_ORIGIN;
    surveyUrl = surveyUrl.endsWith("/") ? surveyUrl : surveyUrl + "/";

    return surveyUrl + "polls/" + questId + "?hash=" + questHash;
}

export default {
    getDefaultMessage,
    generateChatMessagesListFromServerMessagesList,
    convertServerMessageToChatMessageInfo,
    getDefaultNewQuestion,
    getDefaultNewChoice,
    getRandomAwaitingResponseMessage,
    questionTypeNamesMap,
    calculateSurveyLoi,
    getCountryNameForDomainPrefix,
    generatePreviewLink
}